import { Text, Tooltip } from '@radix-ui/themes';
import { ArrowLeft, ArrowRight, ThumbsDown, ThumbsUp } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import useKeyPress from '../hooks/keyPress';

const ActionButtonBar = ({
  actionCallback,
  applicantData,
}: {
  actionCallback: (props: { type: string; applicationId: string }) => void;
  applicantData: { id: string; accepted: boolean };
}) => {
  const { t } = useTranslation();
  const selected = applicantData;
  useKeyPress(
    'ArrowRight',
    () => {
      actionCallback({ type: 'next', applicationId: selected.id });
    },
    applicantData,
  );
  useKeyPress(
    'ArrowLeft',
    () => {
      actionCallback({ type: 'prev', applicationId: selected.id });
    },
    applicantData,
  );

  return (
    <div className="action-button-bar" data-ph-capture-attribute-region="action_bar">
      <div className="action-button-bar-row flex items-center justify-between">
        <Tooltip
          content={
            <Text size="3">
              <strong>{t('swiper.actionBar.previousApplication')}</strong>
            </Text>
          }
        >
          <div
            onClick={() => actionCallback({ type: 'prev', applicationId: selected.id })}
            className="flex items-center justify-center clickable"
          >
            <ArrowLeft id="button-prev" />
          </div>
        </Tooltip>

        <Tooltip
          content={
            <Text size="3">
              <strong>{t('swiper.actionBar.rejectLead')}</strong>
            </Text>
          }
        >
          <div
            onClick={() => actionCallback({ type: 'down-execute', applicationId: selected.id })}
            className="thumbs-down-button flex items-center justify-center clickable"
          >
            <ThumbsDown
              id="button-thumbs-down"
              className={selected.accepted === false ? 'icon thumbs-down-button-rejected' : 'icon'}
            />
          </div>
        </Tooltip>
        <Tooltip
          content={
            <Text size="3">
              <strong>{t('swiper.actionBar.acceptLead')}</strong>
            </Text>
          }
        >
          <div
            onClick={(e) => {
              e.preventDefault();
              actionCallback({ type: 'up-execute', applicationId: selected.id });
            }}
            className="thumbs-up-button flex items-center justify-center clickable"
          >
            <ThumbsUp
              id="button-thumbs-up"
              className={`thumbs-up-button' ${selected.accepted === true ? 'icon thumbs-up-button-accepted' : 'icon'}`}
            />
          </div>
        </Tooltip>

        <Tooltip
          content={
            <Text size="3">
              <strong>{t('swiper.actionBar.nextApplication')}</strong>
            </Text>
          }
        >
          <div
            onClick={() => actionCallback({ type: 'next', applicationId: selected.id })}
            className="flex items-center justify-center clickable"
          >
            <ArrowRight id="button-next" />
          </div>
        </Tooltip>
      </div>
    </div>
  );
};

export default ActionButtonBar;
